import * as ResultsCompany from './resultsCompany.js';
export default ResultsCompany;
